<form [formGroup]="newFolderForm" (ngSubmit)="onSubmit()">
    <div class="modal-header">
        <h5 class="modal-title">Create Folder</h5>
        <button type="button" class="close" (click)="activeModal.close()">
            <span>×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="validation-summary-errors" *ngIf="newFolderForm.touched && newFolderForm.invalid">
            <ul>
                <li *ngIf="newFolderForm.touched && newFolderForm.controls['folderName'].invalid">Folder Name can't be empty.</li>
                <li *ngIf="newFolderForm.touched && newFolderForm.errors?.exists">Folder already exists.</li>
            </ul>
        </div>
        <div class="form-group">
            <label for="input" class="form-control-label">Folder name</label>
            <input
                type="text"
                class="form-control"
                formControlName="folderName"
                [ngClass]="{ 'input-validation-error': newFolderForm.touched && newFolderForm.controls['folderName'].invalid }"
            />
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary btn-sm" [disabled]="formBusy">Ok</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.close()">Cancel</button>
    </div>
</form>
